// List of all trainings Module Selectors
export const getDefaultFilters = ({ trainingMasterModuleList }) => trainingMasterModuleList.searchFilter;
export const getListPageTitle = ({ trainingMasterModuleList }) => trainingMasterModuleList.searchLabel;
export const getListAlertModal = ({ trainingMasterModuleList }) => trainingMasterModuleList.alert;
export const getListConfirmModal = ({ trainingMasterModuleList }) => trainingMasterModuleList.confirmModal;

// Table selectors
export const getCurrentPage = ({ trainingMasterModuleList }) => trainingMasterModuleList.searchFilter.Pagination.Page;
export const getSortModel = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.rowsPerPage;
export const isTableLoading = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.loading;
export const getTableData = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.data;
export const getTotalCount = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.totalCount;
export const getTableSelectedRows = ({ trainingMasterModuleList }) => trainingMasterModuleList.resultTable.selectedRows;


// Training Master Module Add Form
export const getAddFormData = ({ trainingMasterModuleList }) => trainingMasterModuleList.addForm;
export const getAlertModalData = ({ trainingMasterModuleList }) => trainingMasterModuleList.alert;
export const getShowLoading = ({ trainingMasterModuleList }) => trainingMasterModuleList.loading;
export const getUpdateValues = ({ trainingMasterModuleList }) => trainingMasterModuleList.updateValues;

export const validateAddForm = (values) => {
    let errors = {};

    if (values.applicantID === 0) {
        errors[`trainingCategory`] = 'Training Category is required!'
    }

    if (values.interviewer === 0) {
        errors[`trainingName`] = 'Training Name is required!'
    }

    return errors;
}